import React from "react";
export const CardWithTexts = ({ cardText, cardIndex }) => (React.createElement("div", { className: "card-with-texts" },
    React.createElement("p", { className: "card-with-texts--index" }, cardIndex),
    React.createElement("p", { className: "card-with-texts--text", dangerouslySetInnerHTML: {
            __html: cardText || "",
        } })));
